<template>
  <div id="app">
    <PavementBody/>
  </div>
</template>

<script>
import PavementHeader from './components/PavementHeader.vue'
import PavementBody from './components/PavementBody.vue'

export default {
  name: 'app',
  components: {
    PavementHeader,
    PavementBody
  }
}
</script>

<style>
  #app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
  }
</style>
